/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownLeftIcon20Solid = forwardRef('ArrowShapeADownLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.25 17A2.25 2.25 0 0 1 3 14.75V4.573c0-1.202 1.454-1.805 2.304-.954l2.117 2.117 3.352-3.351a2 2 0 0 1 2.828 0l4.013 4.013a2 2 0 0 1 0 2.828l-3.35 3.352 2.117 2.117c.85.85.248 2.305-.955 2.305H5.25Z" })));
});
